<template>
	<div class="plan-book">
		<headerTemplate title="规划书编辑"></headerTemplate>

		<div class="planbook-nav">
			<div class="edit-wapper">
				<span></span>
				<div class="edit-return">
					<van-button type="info" size="mini" @click="planAdd">保存</van-button>
				</div>
			</div>
		</div>
		<div class="planbook-content">
			<van-field v-model="addObj.sellerName" required placeholder="请填写店铺用户名" label="店铺用户名" />
			<van-field v-model="addObj.storeName" required placeholder="请填写店铺名称" label="店铺名称" />
			<van-field v-model="addObj.storeUrl" required placeholder="请填写店铺地址" label="店铺地址" />
			<van-field v-model="addObj.productType" required placeholder="请填写主营产品类型" label="主营产品类型" />
			<van-field v-model="addObj.sourceSupply" placeholder="请填写货源来源" label="货源来源" />
			<van-field v-model="addObj.customerPosition" required placeholder="请填写客户群体定位" label="客户群体定位" />
			<van-field v-model="addObj.pricePosition" required placeholder="请填写商品价格定位" label="商品价格定位" />
			<van-field v-model="addObj.productsNum" placeholder="请填写产品数量" label="产品数量" />
			<van-field v-model="addObj.creditRank" placeholder="请填写信用等级" label="信用等级" />
			<van-field v-model="addObj.startFunds" required placeholder="请填写开办费用" label="开办费用" />
			<van-field v-model="addObj.fixedFunds" required placeholder="请填写固定资产" label="固定资产" />
			<van-field v-model="addObj.flowFunds" required placeholder="请填写流动资金" label="流动资金" />
			<van-field v-model="addObj.recruitsNum" required placeholder="请填写招聘人数" label="招聘人数" />
			<van-field v-model="addObj.peopleDivision" required placeholder="请填写人员分工" label="人员分工" />
			<van-field v-model="addObj.promoteFree" placeholder="请填写选择推广途径与原因(免费)" label="选择推广途径与原因(免费)" />
			<van-field v-model="addObj.expectedFree" placeholder="请填写预期效果(免费)" label="预期效果(免费)" />
			<van-field v-model="addObj.promoteCharges" placeholder="请填写选择推广途径与原因(收费)" label="选择推广途径与原因(收费)" />
			<van-field v-model="addObj.expectedInput" placeholder="请填写预计投入(收费)" label="预计投入(收费)" />
			<van-field v-model="addObj.expectedOutput" placeholder="请填写预计产出(收费)" label="预计产出(收费)" />
			<van-field v-model="addObj.visitorsNum" required placeholder="请填写日均访客数" label="日均访客数" />
			<van-field v-model="addObj.converRate" required placeholder="请填写转化率%" label="转化率%" />
			<van-field v-model="addObj.visitorsDealNum" required placeholder="请填写日成交访客数" label="日成交访客数" />
			<van-field v-model="addObj.customerPrice" required placeholder="请填写课单价" label="课单价" />
			<van-field v-model="addObj.revenue" required placeholder="请填写总收入" label="总收入" />
			<van-field v-model="addObj.totalCost" required placeholder="请填写总成本" label="总成本" />
			<van-field v-model="addObj.income" required placeholder="请填写净收入" label="净收入" />
		</div>

	</div>
</template>

<script>
	import { planAdd, getPlan } from '../../../api/student'
	import headerTemplate from '@/components/headerTemplate/headerTemplate'

	export default {
		name: 'PlanBook',
		components: {
			headerTemplate
		},
		props: [],
		data() {
			return {
				// 是否为编辑状态
				editSta: false,
				shopName: '',
				// 添加
				addObj: {
					sellerName: '',
					storeName: '',
					storeUrl: '',
					productType: '',
					sourceSupply: '',
					customerPosition: '',
					pricePosition: '',
					productsNum: 0,
					creditRank: '',
					startFunds: 0,
					fixedFunds: 0,
					flowFunds: 0,
					recruitsNum: 0,
					peopleDivision: '',
					promoteFree: '',
					expectedFree: '',
					promoteCharges: '',
					expectedInput: 0,
					expectedOutput: 0,
					visitorsNum: 0,
					converRate: 0,
					visitorsDealNum: 0,
					customerPrice: 0,
					revenue: 0,
					totalCost: 0,
					income: 0
				}
			}
		},
		methods: {
			// 添加规划书
			planAdd() {
				if (!this.addObj.sellerName) {
					this.$notify('未填写用户名')
					return false
				}
				if (!this.addObj.storeName) {
					this.$notify('未填写店铺名称')
					return false
				}
				if (!this.addObj.storeUrl) {
					this.$notify('未填写店铺地址')
					return false
				}
				if (!this.addObj.productType) {
					this.$notify('未填写主营产品类型')
					return false
				}
				if (!this.addObj.customerPosition) {
					this.$notify('未填写客户群体定位')
					return false
				}
				if (!this.addObj.pricePosition) {
					this.$notify('未填写商品价格定位')
					return false
				}
				if (this.addObj.startFunds === 0) {
					this.$notify('未填写开办费用')
					return false
				}
				if (this.addObj.fixedFunds === 0) {
					this.$notify('未填写固定资产')
					return false
				}
				if (!this.addObj.flowFunds === 0) {
					this.$notify('未填写流动资金')
					return false
				}
				if (this.addObj.recruitsNum === 0) {
					this.$notify('未填写招聘人数')
					return false
				}
				if (!this.addObj.peopleDivision) {
					this.$notify('未填写人员分工')
					return false
				}
				if (this.addObj.visitorsNum === 0) {
					this.$notify('未填写日均访客数')
					return false
				}
				if (this.addObj.converRate === 0) {
					this.$notify('未填写转化率')
					return false
				}
				if (this.addObj.visitorsDealNum === 0) {
					this.$notify('未填写日成交访客数')
					return false
				}
				if (this.addObj.customerPrice === 0) {
					this.$notify('未填写课单价')
					return false
				}
				if (this.addObj.revenue === 0) {
					this.$notify('未填写总收入')
					return false
				}
				if (this.addObj.totalCost === 0) {
					this.$notify('未填写总成本')
					return false
				}
				if (!this.addObj.income === 0) {
					this.$notify('未填写净收入')
					return false
				}
				planAdd(this.addObj).then(res => {
					alert('保存成功')
				}).catch(error => {
					alert(error.result)
				})
			}
		},
		created() {
			getPlan().then(res => {
				if (res.code === 10000) {
					this.addObj = {
						sellerName: res.result.seller_name,
						storeName: res.result.store_name,
						storeUrl: res.result.store_url,
						productType: res.result.product_type,
						sourceSupply: res.result.source_supply,
						customerPosition: res.result.customer_position,
						pricePosition: res.result.price_position,
						productsNum: res.result.products_num,
						creditRank: res.result.credit_rank,
						startFunds: res.result.start_funds,
						fixedFunds: res.result.fixed_funds,
						flowFunds: res.result.flow_funds,
						recruitsNum: res.result.recruits_num,
						peopleDivision: res.result.people_division,
						promoteFree: res.result.promote_free,
						expectedFree: res.result.expected_free,
						promoteCharges: res.result.promote_charges,
						expectedInput: res.result.expected_input,
						expectedOutput: res.result.expected_output,
						visitorsNum: res.result.visitors_num,
						converRate: res.result.conver_rate,
						visitorsDealNum: res.result.visitors_deal_num,
						customerPrice: res.result.customer_price,
						revenue: res.result.revenue,
						totalCost: res.result.total_cost,
						income: res.result.income
					}
				}
				// console.log(res)
			}).catch(error => {
				this.$router.push('Home')
			})
		}
	}
</script>

<style lang="scss" scoped>
	.plan-book {
		font-size: 12px;

		.planbook-title {
			display: flex;
			align-items: center;
			color: white;
			background-color: #e93b3d;

			.title {
				padding: 10px;
				font-size: 14px;
			}
		}

		.planbook-nav {
			box-shadow: 0 0 5px #E0E0E0;
			margin: 5px 0px;
			padding: 10px 15px;

			.show-wapper {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}

			.edit-wapper {
				display: flex;
				justify-content: space-between;
				align-items: center;

				.edit-return {
					display: flex;
					justify-content: space-around;
					align-items: center;
					color: #409eff;

					.return-font {
						margin-right: 10px;
					}
				}
			}
		}
	}
</style>